import { render, staticRenderFns } from "./ShareLinkCopyComponent.vue?vue&type=template&id=59d85142&scoped=true"
import script from "./ShareLinkCopyComponent.vue?vue&type=script&lang=js"
export * from "./ShareLinkCopyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d85142",
  null
  
)

export default component.exports